<template>
  <v-select
    :label="flag ? 'Etiquetado como' : 'Etiquetar como'"
    outlined
    clearable
    v-model="flag"
    item-text="label"
    item-value="value"
    :items="items"
    @change="handleChange"
  >
    <template v-slot:item="data">
      <v-icon left>{{ data.item.icon }} </v-icon>
      {{ data.item.label }}
    </template>
    <template v-slot:selection="data">
      <v-icon left>{{ data.item.icon }} </v-icon>
      {{ data.item.label }}
    </template>
  </v-select>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Cache } from "aws-amplify";
import { mapGetters } from "vuex";
import router from "../router";
import {
  postSuscripcion,
  deleteSuscripcion,
} from "@/api/private/suscripciones";
export default {
  name: `SeleccionarMarcador`,
  event: "markAsChanged",
  props: {
    proceso: {
      type: Object,
    },
  },
  data() {
    return {
      items: [
        { label: "Revisado", value: "revisado", icon: "mdi-check" },
        { label: "Favorito", value: "favorito", icon: "mdi-star" },
      ],
      flag: Cache.getItem(this.proceso.codigo_proceso),
    };
  },
  methods: {
    handleChange: async function(e) {
      const currentDate = new Date();
      let expiration = new Date(currentDate.getTime());
      expiration.setDate(expiration.getDate() + 10);
      /*       console.log(
        "etiqueta anterior:",
        Cache.getItem(this.proceso.codigo_proceso)
      ); */
      //console.log("nueva etiqueta:", e);
      if (
        Cache.getItem(this.proceso.codigo_proceso) == "favorito" &&
        e != "favorito"
      ) {
        if (router.currentRoute.path == "/dashboard/infima") {
          await deleteSuscripcion({ payload: this.proceso });
        }
      }
      this.flag = e;
      console.log(router.currentRoute.path);
      if (e == "favorito") {
        try {
          //console.log(this.proceso);
          //console.log(this.empresa);
          if (router.currentRoute.path == "/dashboard/infima") {
            await postSuscripcion({
              payload: Object.assign(this.proceso, {
                empresa: this.empresa.razonSocial,
              }),
            });
          }

          //console.log(result)
          Cache.setItem(this.proceso.codigo_proceso, e, {
            expires: expiration.getTime(),
          });
          this.$emit("markAsChanged", {
            codigo_proceso: this.proceso.codigo_proceso,
            markAs: this.flag,
          });
        } catch (e) {
          console.log(e);
        }
      } else if (e == "revisado") {
        Cache.setItem(this.proceso.codigo_proceso, e, {
          expires: expiration.getTime(),
        });
        this.$emit("markAsChanged", {
          codigo_proceso: this.proceso.codigo_proceso,
          markAs: this.flag,
        });
      } else if (e == null) {
        //console.log("Item ha sido removido");
        Cache.removeItem(this.proceso.codigo_proceso);
        this.$emit("markAsChanged", {
          codigo_proceso: this.proceso.codigo_proceso,
          markAs: this.flag,
        });
      }
      AmplifyEventBus.$emit("load-favoritos");

      //await getSuscripcion()

      //console.log(e);
      //console.log(expiration);
      //console.log(this.proceso.codigo_proceso);
      //console.log(Cache.getAllKeys());
      //console.log(Cache.getItem(this.proceso.codigo_proceso));
    },
  },
  computed: {
    ...mapGetters([
      "empresa",
      "user",
      // ...
    ]),
  },
};
</script>
